<section *ngIf="standardData" class="new-home">
  <div>
    <div id="content"></div>
    <div *ngFor="let pack of standardData.details.packages; let packageIndex = index">
      <div *ngFor="let supPackage of pack.subPackages; let subPackageIndex = index">
        <div *ngFor="let component of supPackage.components | filterVisible"
             class="component-section" [class.spacer]="standardData.spacer">
          <div class="component">
            <div [class]="'component-fragment-' + getComponentFragment(component)">

                  <div *ngIf="component.component == 'kla-title'">
                    <kla-title [lineConfig]="supPackage.line" [config]="component.configurations">
                    </kla-title>
                  </div>

                  <div *ngIf="component.component == 'kla-below-highcharts'">
                   <kla-below-highcharts [lineConfig]="supPackage.line"
                                         [config]="component.configurations"
                                         [chartId]="component.configurations.chartId"></kla-below-highcharts>
                  </div>

                  <div *ngIf="component.component == 'kla-right-highcharts'">
                   <kla-right-highcharts [lineConfig]="supPackage.line"
                                         [config]="component.configurations"
                                         [chartId]="component.configurations.chartId"></kla-right-highcharts>
                  </div>

                  <div *ngIf="component.component == 'kla-left-highcharts'">
                   <kla-left-highcharts [lineConfig]="supPackage.line"
                                        [config]="component.configurations"
                                        [chartId]="component.configurations.chartId"></kla-left-highcharts>
                  </div>

                  <div *ngIf="component.component == 'kla-venn-diagram'">
                   <kla-venn-diagram [lineConfig]="supPackage.line"
                                     [config]="component.configurations"></kla-venn-diagram>
                  </div>

                  <div *ngIf="component.component == 'kla-action-plan-progress-chart'">
                    <kla-action-plan-progress-chart [config]="component.configurations"
                                                    [lineConfig]="supPackage.line"></kla-action-plan-progress-chart>
                  </div>

                  <div *ngIf="component.component == 'kla-simple-image'">
                    <kla-simple-image [image]="component.configurations.image"
                                      [imagePosition]="component.configurations.imagePosition"
                                      [lineConfig]="supPackage.line"
                                      [titleConfigurations]="component.configurations.titleConfigurations"
                                      [imageObject]="component.configurations.imageObject">
                      <kla-table content *ngIf="component.configurations.tableConfigurations && component.configurations.tableConfigurations.name"
                                 [config]="component.configurations.tableConfigurations"></kla-table>
                    </kla-simple-image>
                  </div>

                  <div *ngIf="component.component == 'kla-carousel'">
                    <kla-carousel [config]="component.configurations" [lineConfig]="supPackage.line">
                    </kla-carousel>
                  </div>

                  <div *ngIf="component.component == 'kla-outgrow'">
                    <kla-outgrow [config]="component" [lineConfig]="supPackage.line">
                    </kla-outgrow>
                  </div>

                  <div *ngIf="component.component == 'kla-video'">
                    <kla-video [config]="component.configurations">
                    </kla-video>
                  </div>

                  <div *ngIf="component.component == 'kla-indicator-basic'">
                    <kla-indicator-basic [image]="component.configurations.image"
                                         [imagePosition]="component.configurations.imagePosition"
                                         [lineConfig]="supPackage.line"
                                         [config]="component.configurations.indicatorBasicConfigurations"
                                         [cropConfig]="component.configurations.cropConfig"
                                         [imageObject]="component.configurations.imageObject">
                    </kla-indicator-basic>
                  </div>

                  <div *ngIf="component.component == 'kla-line-graph'">
                    <kla-line-graph [lineConfig]="supPackage.line"
                                    [titleConfig]="component.configurations.title"
                                    [chartId]="component.configurations.chartId"
                                    [audioConfig]="component.configurations.audio">
                    </kla-line-graph>
                  </div>

                  <div *ngIf="component.component == 'kla-bar-graph'">
                    <kla-bar-graph [lineConfig]="supPackage.line"
                                   [config]="component.configurations">
                    </kla-bar-graph>
                  </div>

                  <div *ngIf="component.component == 'kla-complex-bar-graph'">
                    <kla-complex-bar-graph [lineConfig]="supPackage.line"
                                           [config]="component.configurations">
                    </kla-complex-bar-graph>
                  </div>

                  <div *ngIf="component.component == 'kla-circle-line-graph'">
                    <kla-circle-line-graph [lineConfig]="supPackage.line"
                                           [config]="component.configurations">
                    </kla-circle-line-graph>
                  </div>

                  <div *ngIf="component.component == 'kla-color-list'">
                    <kla-color-list
                      [lineConfig]="supPackage.line"
                      [config]="component.configurations"
                      [imageObject]="component.configurations.imageObject">
                    </kla-color-list>
                  </div>

                  <div *ngIf="component.component == 'kla-tile-collection'">
                    <kla-tile-collection
                      [config]="component.configurations">
                    </kla-tile-collection>
                  </div>

                  <div *ngIf="component.component == 'kla-intro'">
                    <kla-intro [lineConfig]="supPackage.line" [config]="component.configurations">
                    </kla-intro>
                  </div>

                  <div *ngIf="component.component == 'kla-single-donut-with-image'">
                    <kla-single-donut-with-image [lineConfig]="supPackage.line"
                                                 [config]="component.configurations">
                    </kla-single-donut-with-image>
                  </div>

                  <div *ngIf="component.component == 'kla-thrive-sign-up-form'">
                    <kla-thrive-sign-up-form [config]="component.configurations">
                    </kla-thrive-sign-up-form>
                  </div>

                  <div *ngIf="component.component == 'kla-pictograph'">
                    <kla-pictograph [lineConfig]="supPackage.line"
                                    [config]="component.configurations">
                    </kla-pictograph>
                  </div>

                  <div *ngIf="component.component == 'kla-indicator-multiple-rings'">
                    <kla-indicator-multiple-rings [lineConfig]="supPackage.line"
                                                  [config]="component.configurations">
                    </kla-indicator-multiple-rings>
                  </div>

                  <div *ngIf="component.component == 'kla-ring-graph'">
                    <kla-ring-graph [lineConfig]="supPackage.line"
                                    [config]="component.configurations">
                    </kla-ring-graph>
                  </div>

                  <div *ngIf="component.component == 'kla-indicator-bubble-graph'">
                    <kla-indicator-bubble-graph [lineConfig]="supPackage.line"
                                                [config]="component.configurations">
                    </kla-indicator-bubble-graph>
                  </div>

                  <div *ngIf="component.component == 'kla-survey'">
                    <kla-survey [lineConfig]="supPackage.line"
                                [titleConfig]="component.configurations.title"
                                [surveyConfig]="component.configurations.survey">
                    </kla-survey>
                  </div>

                  <div *ngIf="component.component == 'kla-question'">
                    <kla-question
                      [config]="component.configurations"
                      [imageObject]="component.configurations.imageObject"></kla-question>
                  </div>

                  <div *ngIf="component.component == 'kla-progressbar-with-circle-chart'">
                    <kla-progressbar-with-circle-chart [lineConfig]="supPackage.line" [config]="component.configurations">
                    </kla-progressbar-with-circle-chart>
                  </div>

                  <div *ngIf="component.component == 'kla-multi-image'">
                    <kla-multi-image [lineConfig]="supPackage.line"
                                     [titleConfig]="component.configurations.titleConfigurations"
                                     [chartId]="component.configurations.chartId">
                    </kla-multi-image>
                  </div>

                  <div *ngIf="component.component == 'kla-script'">
                    <kla-script [config]="component.configurations">
                    </kla-script>
                  </div>

                  <div *ngIf="component.component == 'kla-action-taxonomy'">
                    <kla-action-plan-taxanomy
                      [collapseChildren]="true"
                      [config]="component.configurations"
                      [lineConfig]="supPackage.line">
                    </kla-action-plan-taxanomy>
                  </div>
                  <div *ngIf="component.component == 'new-action-taxonomy'">
                    <kla-new-action-taxonomy
                    [config]="component.configurations"
                    [mainSiteColor]="mainSiteColor"
                    [lineConfig]="supPackage.line">
                    </kla-new-action-taxonomy>
                  </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</section>
